import { render } from 'react-dom'
// import { install } from 'resize-observer'
import App from './App'

// import reportWebVitals from './reportWebVitals';
import './index.scss'
// import { getNativeInfo } from '@docs/common'

// // install 影响vconsole的显示 线上环境按照之前的方式 执行install
// if (!['qa', 'smoke', 'stress', 'sqa'].includes(process.env.REACT_APP_DEPLOY_ENV)) {
//   install()
// }

// else {
// getNativeInfo().then((res) => {
//   if (res?.email.includes('anker.com') || res?.email.includes('anker-in.com')) {
//     renderConsole()
//   }
// })
// }

function handlePCSChange(evt) {
  console.log('handlePCSChange', evt);
  document.body.classList.toggle('dark-theme', Boolean(evt?.matches))
}

// 低版本不存在 addEventListener 方法
window.matchMedia('(prefers-color-scheme: dark)').addEventListener?.('change', handlePCSChange)

handlePCSChange(window.matchMedia('(prefers-color-scheme: dark)'))

render(<App />, document.getElementById('root'))

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
